<template>
   <div class="form-group">
      <label
         for="ip_Lname"
         :class="['label-overlay', { active: !isNotEmpty(form.lname) }]"
         @click="switchLabel($event)"
      >
         Last Name
      </label>
      <input
         id="ip_Lname"
         v-model.trim="form.lname"
         type="text"
         class="form-control"
         name="lastname"
         :class="[{ 'is-invalid': isValidLname.isInvalid }, { 'is-valid': isValidLname.isValid }]"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateLnameData();
            initiatedType();
         "
      />
      <div class="invalid-feedback">What's your last name?</div>
      <div class="valid-feedback">Good last name.</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';

export default {
   name: 'LnameComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      options: {
         type: Object,
         default: null,
      },
   },
   data() {
      return {
         isValidLname: {
            isInvalid: false,
            isValid: false,
         },
         form: {
            lname: this.value,
         },
         ...(process.browser && { userProfileTracker: this.$tracker.userProfile }),
         person,
         ...(process.browser && { tracker: this.$tracker.tracker }),
      };
   },

   mounted() {
      if (this.person.profileData) {
         // this.form.lname = this.person.profileData.lname || '';
      }
   },
   methods: {
      validateLnameData() {
         this.isValidLname.isValid = !this.isNotEmpty(this.form.lname);
         this.isValidLname.isInvalid =
            this.$parent.attemptSubmit && this.isNotEmpty(this.form.lname);
      },

      reset() {
         this.isValidLname.isInvalid = false;
         this.isValidLname.isValid = false;
         this.form.lname = '';
      },

      initiatedType() {
         if (this.form.lname !== '') {
            this.userProfileTracker.information({ lname: this.form.lname });
         }

         if (
            typeof this.$parent.isFormInitiated === 'undefined' &&
            this.options &&
            this.options.mixpanelEve
         ) {
            this.$parent.isFormInitiated = true;

            this.tracker(this.options.mixpanelEve, {
               ...(this.options.name && { Name: this.options.name }),
               ...(this.options.type && { Type: this.options.type }),
               ...(this.options.product && { Product: this.options.product }),
               ...(this.options.framework && { Framework: this.options.framework }),
            });
         }
      },
   },
};
</script>

<style></style>
